import { ASYNC_STATUS } from 'utils/constants/flow.constant';
import { FLOW } from 'redux/actions/Types';
import { addFlowEdgesCheck } from 'redux/reducer/FlowReducer/addFlowEdgesCheck';
import { deleteSelectedFlowTagsInformation } from 'redux/reducer/FlowReducer/deleteSelectedFlowTagsInformation';
import { editQuestionEdgeDialog } from 'redux/reducer/FlowReducer/editQuestionEdgeDialog';
import { getDeleteEdgesByNodeId } from 'redux/reducer/FlowReducer/getDeleteEdgesByNodeId';
import { getDeleteFlowNodeById } from 'redux/reducer/FlowReducer/getDeleteFlowNodeById';
import {
  getNodesCompleteDetailsInitialState, initialState,
} from 'redux/reducer/FlowReducer/constants';
import { getSelectedFlow } from 'redux/reducer/FlowReducer/getSelectedFlow';
import {
  mutateAPIEdges,
  mutateAPIFlowNodeResponse,
} from 'redux/reducer/FlowReducer/mutateAPIFlowResponse';
import { onConnectFlowEdges } from 'redux/reducer/FlowReducer/onConnectFlowEdges';
import { openFlowDialogEdgesConnection } from 'redux/reducer/FlowReducer/openFlowDialogEdgesConnection';
import { updateCreateNodeSuccess } from 'redux/reducer/FlowReducer/updateCreateNode';
import { updateFlowEdges } from 'redux/reducer/FlowReducer/updateFlowEdges';
import { updateFlowNodes } from 'redux/reducer/FlowReducer/updateFlowNodes';
import { updateFlowNodesCompleteDetails } from 'redux/reducer/FlowReducer/updateFlowNodesCompleteDetails';
import { updateSelectedFlowInformation } from 'redux/reducer/FlowReducer/updateSelectedFlowInformation';


export const FlowReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~ new verified flow state
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    case FLOW.FETCH_FLOW_DETAILS_SUCCESS:
      return {
        ...state,
        flowNodesAndEdgesLoaded: payload.flowNodesAndEdgesLoaded,
        cleanRoomFlow: payload,
        flow: payload.flow,
        nodes: mutateAPIFlowNodeResponse(payload.flow?.nodes),
        edges: mutateAPIEdges(payload.flow?.edges),
      };
    case FLOW.ADD_TEMPORARY_NODE_TO_FLOW:
      return { ...state, nodes: [...state.nodes, payload] };

    case FLOW.UPDATE_FLOW_NODES:
      return { ...state, nodes: updateFlowNodes(payload, state.nodes) };

    case FLOW.UPDATE_SINGLE_NODE_DATA: {
      const updatedNodes = state.nodes.map(node => {
        if (node.id === payload.nodeId) {
          return {
            ...node,
            data: {
              ...node.data,
              ...payload.data,
              // Preserve level if not in new data
              level: payload.data.level ?? node.data.level,
            },
          };
        }
        return node;
      });

      return {
        ...state,
        nodes: updatedNodes,
      };
    }

    case FLOW.CREATE_NODE_SUCCESS:
      return { ...state, nodes: updateCreateNodeSuccess(payload, state.nodes) };

    case FLOW.CLEAR_FLOW_CACHE:
      return {
        ...state,
        edges: [],
        nodes: [],
        flow: getSelectedFlow(state.listOfFlows, ''),
        nodesCompleteDetails: {
          status: ASYNC_STATUS.IDLE,
          error: false,
        },
      };

    case FLOW.FETCH_FLOW_NODES_COMPLETE_DETAILS:
      return {
        ...state,
        nodesCompleteDetails: {
          status: ASYNC_STATUS.LOADING,
          error: false,
        },
      };
    case FLOW.FETCH_FLOW_NODES_COMPLETE_DETAILS_SUCCESS:
      return {
        ...state,
        nodes: updateFlowNodesCompleteDetails(payload.nodesCompleteDetailsMap, state.nodes),
        nodesCompleteDetails: {
          status: ASYNC_STATUS.SUCCEEDED,
          error: false,
        },
      };
    case FLOW.FETCH_FLOW_NODES_COMPLETE_DETAILS_ERROR:
      return {
        ...state,
        nodesCompleteDetails: {
          status: ASYNC_STATUS.FAILED,
          error: true,
        },
      };
    case FLOW.CLEAR_FLOW_NODES_COMPLETE_DETAILS:
      return {
        ...state,
        ...getNodesCompleteDetailsInitialState(),
      };
    case FLOW.DELETE_FLOW_NODE_SUCCESS:
      return {
        ...state,
        nodes: getDeleteFlowNodeById(payload, state.nodes),
        edges: getDeleteEdgesByNodeId(payload, state.edges),
      };

    case FLOW.OPEN_SIDE_PANEL:
      return {
        ...state,
        sidePanel: {
          open: true,
          type: payload.type,
          data: payload.data,
        },
      };
    case FLOW.CLOSE_SIDE_PANEL:
      return {
        ...state,
        sidePanel: { open: false, data: { } },
      };

    case FLOW.CHECK_FLOW_EDGES_CONNECTION:
      return {
        ...state,
        sidePanel: openFlowDialogEdgesConnection(
          payload, state.nodes,
        ),
      };
    case FLOW.CLOSE_CHECK_FLOW_EDGES_CONNECTION:
      return {
        ...state,
        sidePanel: { open: false, isLoading: false, data: { } },
      };
    case FLOW.CONNECT_NODES_WITH_EDGE:
      return {
        ...state,
        sidePanel: {
          ...(state.sidePanel ? state.sidePanel : {}),
          isLoading: true,
        },
      };
    case FLOW.CONNECT_NODES_WITH_EDGE_SUCCESS:
      return {
        ...state,
        edges: addFlowEdgesCheck(payload, state.edges),
        sidePanel: { open: false, isLoading: false, data: { } },
      };
    case FLOW.CONNECT_NODES_WITH_EDGE_ERROR:
      return {
        ...state,
        sidePanel: {
          ...(state.sidePanel ? state.sidePanel : {}),
          isLoading: false,
        },
      };
    case FLOW.EDIT_QUESTION_EDGE:
      return {
        ...state,
        sidePanel: editQuestionEdgeDialog(
          payload, state.nodes,
        ),
      };
    case FLOW.UPDATE_FLOW_EDGES:
      return { ...state, edges: updateFlowEdges(payload, state.edges) };
    case FLOW.CONNECT_FLOW_EDGES:
      return {
        ...state,
        edges: onConnectFlowEdges(payload, state.edges),
      };

    case FLOW.UPDATE_SELECTED_FLOW:
      return {
        ...state, flow: getSelectedFlow(state.listOfFlows, payload.flowID),
      };

    case FLOW.UPDATE_SELECTED_FLOW_INFORMATION:
      return {
        ...state,
        flow: updateSelectedFlowInformation(state.flow, payload.type, payload.value),
      };

    case FLOW.DELETE_SELECTED_FLOW_INFORMATION_TAGS:
      return {
        ...state,
        flow: deleteSelectedFlowTagsInformation(state.flow, payload.index),
      };

    case FLOW.DELETE_SELECTED_FLOW_INFORMATION_ALL_TAGS:
      return {
        ...state,
        flow: {
          ...state.flow,
          tags: [],
        },
      };
    case FLOW.NODE_SIZE_CHANGE:
      return {
        ...state,
        nodeSize: payload,
      };
    case FLOW.SELECT_START_LEVEL_FOR_CACHED_RUN:
      return {
        ...state,
        selectedStartLevel: payload,
      };
    case FLOW.SELECT_PAUSE_LEVEL_FOR_CACHED_RUN:
      return {
        ...state,
        selectedPauseLevel: payload,
      };
    case FLOW.SET_FLOW_CACHED_MODE:
      return {
        ...state,
        isFlowCachedMode: payload,
      };
    case FLOW.SET_INCLUDED_NODES_BY_BRANCHES:
      return {
        ...state,
        includedNodeIds: payload,
      };
    case FLOW.CLEAR_INCLUDED_NODES_BY_BRANCHES:
      return {
        ...state,
        includedNodeIds: [],
      };
    case FLOW.FETCH_FLOW_DETAILS_ERROR:
    case FLOW.CREATE_NODE:
    case FLOW.DELETE_FLOW_NODE:
    case FLOW.DELETE_FLOW_NODE_ERROR:
    default:
      return {
        ...state,
      };
  }
};
